import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { clearUser } from "../../redux/slices/userSlice";
import { getLanguage } from "../../utils/getLanguage";
import LanguageSwitcher from "../LanguageSwitcher";

const SuperadminHeader = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const lang = getLanguage();
  const dispatch = useDispatch();

  const handleSignOut = () => {
    dispatch(clearUser());
    navigate(`/${lang}/login`);
  };

  return (
    <header className="bg-gray-800 text-white shadow-md">
      <div className="container mx-auto flex items-center justify-between px-4 py-4 sm:px-8">
        <div>
          <h1 className="text-2xl font-semibold">Superadmin Dashboard</h1>
          <p className="text-sm text-purple-200">Manage users and system settings</p>
        </div>
        <div className="flex items-center space-x-4">
          <LanguageSwitcher />
          <button
            onClick={handleSignOut}
            className="rounded-lg bg-red-500 px-4 py-2 font-semibold text-white transition duration-300 hover:bg-red-600"
          >
            {t("Sign Out")}
          </button>
        </div>
      </div>
    </header>
  );
};

export default SuperadminHeader;
